import type { FlipperFlag, LegacyProductFlag } from './constants/productFlipperFlagRelation';
import { productFlipperFlagRelations } from './constants/productFlipperFlagRelation';

export type ProductFlagValues = Record<LegacyProductFlag, boolean>;
export type FlipperFlagValues = Record<FlipperFlag, boolean>;
export type FlagValues = ProductFlagValues & FlipperFlagValues;

export class ProductFlipperFlagService {
  getProductNameForFlipper = (flipperFlag: FlipperFlag): LegacyProductFlag | undefined => {
    const foundRelation = productFlipperFlagRelations.find((relation) => relation.flipper === flipperFlag);
    return foundRelation ? foundRelation.product : undefined;
  };

  getFlipperNameForProduct = (productFlag: LegacyProductFlag): FlipperFlag | undefined => {
    const foundRelation = productFlipperFlagRelations.find((relation) => relation.product === productFlag);
    return foundRelation ? foundRelation.flipper : undefined;
  };

  getFlipperNamesForProducts = (productFlags: LegacyProductFlag[]): FlipperFlag[] => {
    return productFlags.map(this.getFlipperNameForProduct).filter((flag): flag is FlipperFlag => !!flag);
  };

  getFlipperOverridesForProductFlags = (flipperFlags: FlipperFlagValues): ProductFlagValues => {
    const result = {};

    Object.entries(flipperFlags).forEach(([flipperFlagName, flipperFlagValue]) => {
      const productFlag = this.getProductNameForFlipper(flipperFlagName);
      if (!productFlag) return;
      result[productFlag] = flipperFlagValue;
    });

    return result;
  };

  mergeFlags = (baseFlags: FlagValues, overridingFlags: FlagValues): FlagValues => {
    const result = { ...baseFlags };

    Object.keys(overridingFlags).forEach((flagToBeOverridden) => {
      result[flagToBeOverridden] = overridingFlags[flagToBeOverridden] || result[flagToBeOverridden];
    });

    return result;
  };
}
